import { RootAction } from '@src/app/_redux';
import { EMAIL_POSTAL_CODE_LOGIN_INITIATE } from '@src/app/login/weak/emailpostalcode/actions';
import { combineReducers } from 'redux';

export type State = {
  email: string;
  postalCode: string;
};

export const reducer = combineReducers<State, RootAction>({
  email: (state = '', action) => {
    switch (action.type) {
      case EMAIL_POSTAL_CODE_LOGIN_INITIATE:
        return action.payload.email;
      default:
        return state;
    }
  },
  postalCode: (state = '', action) => {
    switch (action.type) {
      case EMAIL_POSTAL_CODE_LOGIN_INITIATE:
        return action.payload.postalCode;
      default:
        return state;
    }
  },
});
